'use client';
import { create } from 'zustand';
import { ActionFeedbackProps } from '../../ui/shared/module-actions-feedback';
import { StudySessions, StudySessionsOptions } from '../types/study-sessions';

type StudySessionState = {
  actionFeedback: ActionFeedbackProps | null;
  profileStudySessions: StudySessions[0] | null;
  studySessionsOptions: StudySessionsOptions | null;
  error: Error | null;
  isLoading: boolean;
  setProfileStudySessions: (profileStudySessions: StudySessions[0] | null) => void;
  setStudySessionsOptions: (sessionOptions: StudySessionsOptions | null) => void;
  setActionFeedback: (feedback: ActionFeedbackProps | null) => void;
  setIsLoading: (status: boolean) => void;
  setError: (error: Error | null) => void;
  resetStore: () => void;
};

const initialState: Omit<
  StudySessionState,
  | 'setProfileStudySessions'
  | 'setStudySessionsOptions'
  | 'setActionFeedback'
  | 'setError'
  | 'setIsLoading'
  | 'resetStore'
> = {
  actionFeedback: null,
  error: null,
  isLoading: false,
  studySessionsOptions: null,
  profileStudySessions: null,
};

export const useStudySessionStore = create<StudySessionState>((set) => ({
  ...initialState,
  setProfileStudySessions: (profileStudySessions: StudySessions[0] | null) =>
    set({ profileStudySessions }),
  setStudySessionsOptions: (studySessionsOptions: StudySessionsOptions | null) =>
    set({ studySessionsOptions }),
  setIsLoading: (isLoading: boolean) => set({ isLoading }),
  setError: (error: Error | null) => set({ error }),
  setActionFeedback: (actionFeedback) => set({ actionFeedback }),
  resetStore: () => set(initialState),
}));
